(function() { window.GUID_45ec8237_efde_4961_948a_a59db5c001cc = { getGuid: function() { return "45ec8237-efde-4961-948a-a59db5c001cc"; } }; })();
var selectedEntityIdAutoComplete = $('#SelectedEntityIdAutoComplete');
$(function () {
    if (document.SelectedEntityId != null) {
        document.SelectedEntityId.FreezedElementScrollWhenOpen = $('#SearchResult');
        document.SelectedEntityId.SelectionChange = function () {
            selectedEntityIdAutoComplete.blur();
            var data = {};
            data.entityId = this.val();
            CompuSport.Ajax.Get(CSParameters.RUrl + "Account/UserCardPlayer/" + CSParameters.SportEventId, data, function (queryResult) {
                $('#UserCardContainer').html(queryResult);
            });
        };
    }
});

//# sourceMappingURL=UserCard.js.map
